import { Component, OnDestroy } from '@angular/core';
import { EditTaskflowTemplateComponent } from 'components/task/taskflow-template/edit-taskflow-template.component';
import { CredentialType } from 'enums/CredentialType';
import { TaskflowTemplateModel } from 'models/generated/Entities.GormCrm.TaskflowTemplate';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription } from 'rxjs';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { NotificationService } from 'services/notification.service';
import { PushService } from 'services/push.service';
import { TaskflowTemplateService } from 'services/taskflow-template.service';

@Component({
	selector: 'list-taskflow-template',
	templateUrl: './list-taskflow-template.component.html',
	imports: [Layout, ListView, TranslatePipe, CustomDatePipe]
})
@ComponentUrl('list-taskflow-template')
@CredentialRequired(CredentialType.EditTaskflowTemplates)
export class ListTaskflowTemplateComponent implements OnDestroy {

	taskflowTemplates: TaskflowTemplateModel[] = [];
	selectedTaskflowTemplateId?: string;
	onTaskflowTemplateChanges: Subscription;

	constructor(private readonly navigation: NavigationService,
		private readonly pushService: PushService,
		private readonly taskflowTemplateService: TaskflowTemplateService,
		private readonly notification: NotificationService) {
		this.updateTaskflowTemplates();

		this.onTaskflowTemplateChanges = this.pushService.onTaskflowTemplateChanges.subscribe(() => {
			this.updateTaskflowTemplates();
		});
	}

	updateTaskflowTemplates() {
		this.taskflowTemplateService.getTemplates().then(templates => {
			this.taskflowTemplates = templates;
		});
	}

	deleteTaskflowTemplates(taskflowTemplateId?: string) {
		if (!taskflowTemplateId) return;
		this.notification.confirm('general.prompt-for-delete').subscribe(result => {
			if (result)
				this.taskflowTemplateService.deleteTemplate(taskflowTemplateId);
		});
	}

	createTaskflow() {
		this.selectedTaskflowTemplateId = undefined;
		this.navigation.openRelativeView(this, 'edit-taskflow-templates', EditTaskflowTemplateComponent)
			.then(view => view.loadTaskflowTemplate(new TaskflowTemplateModel));
	}

	editTaskflow(taskflowTemplateId?: string) {
		this.selectedTaskflowTemplateId = taskflowTemplateId;
		if (taskflowTemplateId)
			this.navigation.openRelativeView(this, 'edit-taskflow-templates', EditTaskflowTemplateComponent)
				.then(view => view.taskflowTemplateId = taskflowTemplateId);
	}

	ngOnDestroy() {
		this.onTaskflowTemplateChanges.unsubscribe();
	}
}
